import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import './debug-json-view.component.scss';

@Component({
    selector: 'debug-json-view',
    template: require('./debug-json-view.component.html'),
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class JsonDebugViewComponent {
    @Input() data: any;
    @Input() displayLastComma: boolean
    @Input() isParent = true;
    @Input() hideOpeningBracket = false;

    get isObject(): boolean {
        return typeof this.data === 'object';
    }

    keys(value: any): string[] {
        return Object.keys(value);
    }

    isArray(value: any): boolean {
        return Array.isArray(value);
    }

    isPrimitive(value: any): boolean {
        return typeof(value) === 'string' || typeof(value) === 'number' || typeof(value) === 'boolean' || value instanceof Date;
    }

    getPrimitiveValue(value: any): any {
        if (typeof(value) === 'string') {
            return `"${value}"`;
        }

        return value;
    }

    copy(): void {
        const data = this.isPrimitive(this.data)
            ? this.getPrimitiveValue(this.data)
            : JSON.stringify(this.data, null, "\t");

        navigator.clipboard.writeText(data);
    }
}